import React from 'react';
import { APIs } from '../modules/apiClient';
import http from '../modules/api';
import PopupFrameV2 from '../modules/popup/PopupFrameV2';
import SaveDialogV2 from '../modules/dialogs/SaveDialogV2';
import BasicDialogV2 from '../modules/dialogs/BasicDialogV2';
import Button from '../modules/common/Button';
import CheckBox from '../modules/common/CheckBox';
import RpProductListStatisticsForPopup from './RpProductListStatisticsForPopup'
import RpSelectCategory from './RpSelectCategory'
import RpProductKeywordInputList from './RpProductKeywordInputList';
import RpTotalItemCountInput from './RpTotalItemCountInput';

import default_plus_img from '../../resources/img/default_plus.svg';
import default_minus_img from '../../resources/img/default_minus.svg';

export class RpCafe24ClonePopupByRpSelaPrice extends React.Component {
    constructor(props) {
		super(props);
		this.state = {
            org_event_setting_obj: props.org_event_setting_obj || {}, 

            org_unique_product_keyword_list : [
                ...new Set(
                    JSON.parse((props.org_event_setting_obj?.manual_json || []))
                    .flatMap(item => item.product_keyword_list || [])
                    .map(keyword => (keyword || "").trim())
                    .filter(keyword => keyword !== "")
                )
            ],
            org_unique_product_except_keyword_list : [
                ...new Set(
                    JSON.parse((props.org_event_setting_obj?.manual_json || []))
                    .flatMap(item => item.product_except_keyword_list || [])
                    .map(keyword => (keyword || "").trim())
                    .filter(keyword => keyword !== "")
                )
            ],

            show_clone_popup_frame: true,
            current_clone_Step: 1,

            clone_iframe_page_id: props.org_event_setting_obj.iframe_page_id || undefined,
            clone_cafe24_main_display_group: undefined,
            clone_cafe24_category_no: undefined,
            clone_cafe24_category_display_group: props.org_event_setting_obj.cafe24_category_display_group || undefined,
            clone_cafe24_product_cnt: 0,
            clone_cafe24_category_display_type: props.org_event_setting_obj.cafe24_category_display_type || undefined,
            clone_sub_category_product_display: undefined,
            clone_category_depth: undefined,
            clone_cafe24_category_no_list: [],
            clone_cafe24_category_list: [],

            category_no_1 : "",
            category_no_2 : "",
            category_no_3 : "",
            category_no_4 : "",
            category_list_1 : [],
            category_list_2 : [],
            category_list_3 : [],
            category_list_4 : [],

            excludeCategoryList: [this.newCategoryBlock()],

            excludedKeywords: [""], // 상품명에 포함되면 제외할 단어 리스트
            includedKeywords: [""], // 상품명에 포함되면 선정할 단어 리스트

            totalItemCount: props.org_event_setting_obj["product_cnt"] ?? 10,
            max_item_analysis: props.org_event_setting_obj["max_item_analysis"] ?? 1,

            is_main_auto_display_use: false,
            is_category_auto_display_use: false,

            clone_selected_display_name_group: "",
            clone_selected_last_category_name: "",

            rp_event_setting_link: "",
            is_break: true,

            is_check_not_modify_1: false,
            is_check_not_modify_2: false,
            is_check_not_modify_3: false,
            is_check_not_modify_4: false,
            is_check_not_modify_5: this.props.is_check_not_modify_5 ?? false,
            is_check_not_modify_6: (this.props.is_check_not_modify_6 || (props.org_event_setting_obj["max_item_analysis"] ?? 1) == 1) ?? false,

            selected_price_cd : this.props.selected_price_cd || null,
        }
    }

    newCategoryBlock = () => ({
        id: Date.now() + Math.random(),
        category_no_1: "",
        category_no_2: "",
        category_no_3: "",
        category_no_4: "",
        category_list_1: [],
        category_list_2: [],
        category_list_3: [],
        category_list_4: [],
    });

    componentWillMount() {
	
    }

	componentDidMount() {
        console.log("### org_event_setting_obj", this.state.org_event_setting_obj);
    }

    componentDidUpdate() {
    
    }

    componentWillUnmount(e) {
    
    }

    handleToggle = (state, autoCloseSecond) => {
        this.setState({
            [state] : !this.state[state],
            current_clone_Step : 1,
        }, () => {
            if(autoCloseSecond){
                setTimeout(() => {this.setState({ [state] : !this.state[state] })}, autoCloseSecond*1000)
            }
        });
    }
    
    nextCloneStep = (currentStep, is_break) => {
        if (currentStep == 1
            && !this.state.clone_iframe_page_id) {
                this.setState({
                    show_non_select_page : true
                })
        } else if (currentStep == 1 
            && !(this.state.clone_cafe24_main_display_group || this.state.clone_cafe24_category_no)) {
                this.setState({
                    show_non_select_page : true
                })
        } else if (currentStep == 6
            && (!this.state.totalItemCount || Number(this.state.totalItemCount) == 0) 
            && this.state["is_check_not_modify_"+currentStep] == false
        ) {
            this.setState({
                show_non_total_cnt : true,
            })
        } else if (currentStep == 6
            && this.state.clone_iframe_page_id == "robomd_cafe24_main_page"
            && this.state["is_check_not_modify_"+currentStep] == false
            && this.state.totalItemCount > 200
        ) {
                this.setState({
                    show_over_total_cnt : true,
                })
        } else if (currentStep == 6
            && this.state.clone_iframe_page_id == "robomd_cafe24_main_page"
            && this.state["is_check_not_modify_"+currentStep] == true
            && this.state.org_event_setting_obj["product_cnt"] > 200
        ) {
            this.setState({
                show_over_total_cnt : true,
            })
        } else {
            if (currentStep == 4
                && (
                    !(this.state.org_unique_product_keyword_list.length > 0 || this.state.org_unique_product_except_keyword_list.length > 0)
                    || this.props.is_check_not_modify_5 == true
                )
            ) { // 기존의 등록된 키워드가 없는 경우
                currentStep++; // 다음 스텝 건너띔
                this.setState({
                    is_check_not_modify_5 : true,
                })
            } 

            if (currentStep == 5
                && this.props.is_check_not_modify_6 == true
            ) {
                currentStep++; // 다음 스텝 건너띔
                this.setState({
                    is_check_not_modify_6 : true,
                })
            }

            this.setState({
                current_clone_Step : !is_break ? (Number(currentStep)+1 != 8 
                                                                            ? Number(currentStep) == 1 ? Number(currentStep)+2: Number(currentStep)+1 
                                                                            : 7) : 7,
                is_break : is_break ? is_break : false,
            }, () => {
                if (this.state.current_clone_Step == 7) {
                    // 카페24 자동진열을 사용 중인지 여부 조회
                    if (this.state.is_check_not_modify_1 == true) {
                        this.loadCategoryAutoLayoutList(this.state.org_event_setting_obj["cafe24_category_no_list"], this.state.org_event_setting_obj["cafe24_main_display_group"]); 
                    } else {
                        this.loadCategoryAutoLayoutList(this.state.clone_cafe24_category_no, this.state.clone_cafe24_main_display_group); 
                    }
                }

                if (this.state.current_clone_Step == 7
                    && this.state.is_check_not_modify_1 == true
                    && this.state.org_event_setting_obj["iframe_page_id"] == "robomd_cafe24_category_page"
                ) {
                    this.checkCafe24CategorySettingByOrgCategoryNo(); // 원본 진열의 카테고리 번호의 하위 카테고리 진열 여부 조회
                }
            });
        }
    }
    prevCloneStep = (currentStep) => {
        if (currentStep == 7
            && this.props.is_check_not_modify_6 == true
        ) {
            currentStep--; // 이전 스텝 건너띔
        } 
        if (currentStep == 6
            && (
                !(this.state.org_unique_product_keyword_list.length > 0 || this.state.org_unique_product_except_keyword_list.length > 0)
                || this.props.is_check_not_modify_5 == true
            )
        ) { // 기존의 등록된 키워드가 없는 경우
            currentStep--; // 이전 스텝 건너띔
        }
        if (currentStep == 3) {
            currentStep--; // 이전 스텝 건너띔
        }

        this.setState({
            current_clone_Step : Number(currentStep)-1 > 1 ? this.state.is_break ? 2 : Number(currentStep)-1 : 1,
        });
    }

    onChangeMainGroupOrCategory = (pageId, mainDisplayGroup, categoryNo, categoryDisplayGroup, productCnt, cafe24CategoryDisplayType, subCategoryProductDisplay, categoryDepth, cafe24CategoryNoList, cafe24CategoryList,
        selectedDisplayNameGroup,
        selectedLastCategoryName
    ) => {
        console.log('상위 함수 실행됨!');
        console.log('iframePageId:', pageId);
        console.log('mainDisplayGroup:', mainDisplayGroup);
        console.log('cafe24CategoryNo:', categoryNo);
        console.log('cafe24CategoryDisplayGroup:', categoryDisplayGroup);
        console.log('cafe24ProductCnt:', productCnt);
        console.log('cafe24CategoryDisplayType:', cafe24CategoryDisplayType);
        console.log('subCategoryProductDisplay:', subCategoryProductDisplay);
        console.log('categoryDepth:', categoryDepth);
        console.log('cafe24CategoryNoList:', cafe24CategoryNoList);
        console.log('cafe24CategoryList:', cafe24CategoryList);
        console.log('selectedDisplayNameGroup:', selectedDisplayNameGroup);
        console.log('selectedLastCategoryName:', selectedLastCategoryName);

        this.setState({
            clone_iframe_page_id: pageId,
            clone_cafe24_main_display_group: mainDisplayGroup,
            clone_cafe24_category_no: categoryNo,
            clone_cafe24_category_display_group: categoryDisplayGroup,
            clone_cafe24_product_cnt: productCnt,
            clone_cafe24_category_display_type: cafe24CategoryDisplayType,
            clone_sub_category_product_display: subCategoryProductDisplay,
            clone_category_depth: categoryDepth,
            clone_cafe24_category_no_list: cafe24CategoryNoList,
            clone_cafe24_category_list: cafe24CategoryList,

            clone_selected_display_name_group: selectedDisplayNameGroup,
            clone_selected_last_category_name: selectedLastCategoryName,
        })
    };

    onCategoryChange(category_no_1,
        category_no_2,
        category_no_3,
        category_no_4,
        category_list_1,
        category_list_2,
        category_list_3,
        category_list_4,
    ) {
            this.setState({
                category_no_1,
                category_no_2,
                category_no_3,
                category_no_4,
                category_list_1,
                category_list_2,
                category_list_3,
                category_list_4,
            }, () => {
                console.log("## categoryChange", 
                    this.state.category_no_1,
                    this.state.category_no_2,
                    this.state.category_no_3,
                    this.state.category_no_4,
                    this.state.category_list_1,
                    this.state.category_list_2,
                    this.state.category_list_3,
                    this.state.category_list_4,
                )
            })
    }

    handleAddExcludeCategory = () => {
        this.setState(prev => ({
          excludeCategoryList: [...prev.excludeCategoryList, this.newCategoryBlock()]
        }));
    };
    
    handleRemoveExcludeCategory = (id) => {
        this.setState(prev => ({
            excludeCategoryList: prev.excludeCategoryList.filter(item => item.id !== id)
        }));
    };
    
    handleCategoryChange = (id, cat1, cat2, cat3, cat4, list1, list2, list3, list4) => {
        this.setState(prev => ({
          excludeCategoryList: prev.excludeCategoryList.map(item =>
            item.id === id
              ? {
                  ...item,
                  category_no_1: cat1,
                  category_no_2: cat2,
                  category_no_3: cat3,
                  category_no_4: cat4,
                  category_list_1: list1,
                  category_list_2: list2,
                  category_list_3: list3,
                  category_list_4: list4,
                }
              : item
          )
        }), () => {
            console.log("## categoryChange", 
                cat1,
                cat2,
                cat3,
                cat4,
                list1,
                list2,
                list3,
                list4,
            )
        });
    };

    handleExcludeKeywordChange = (keywordList) => {
        this.setState({ excludedKeywords: keywordList });
        // 필요 시 여기서 API 저장 준비하거나 다른 로직 호출
    };
    handleIncludeKeywordChange = (keywordList) => {
        this.setState({ includedKeywords: keywordList });
        // 필요 시 여기서 API 저장 준비하거나 다른 로직 호출
    };

    handleTotalItemCountChange = (value) => {
        this.setState({ totalItemCount: value });
        // 필요시 다른 로직 예: 자동 조정, 유효성 검사 등
    };

    getScheduleText(obj) {
        if (!obj) return "";

        // 조건에 따라 강제 설정
        if (obj.auto_create_yn === "Y") {
            if (this.state?.totalItemCount > 100) {
                // 101개 이상 선정하는 경우, '일별' + '새벽 3시'로 강제함.
                obj.event_cycle_type = "A8001";
                obj.event_time = "3";
            }
        
            const type = obj.event_cycle_type;
        
            if (obj.auto_create_yn !== "Y") return "";
        
            // 일별 (A8001)
            if (type === "A8001") {
            const day = obj.event_cycle ? `${obj.event_cycle}일마다` : "";
            const time = obj.event_time ? `${obj.event_time}시에` : "";
            return [day, time].filter(Boolean).join(" ");
            }
        
            // 요일별 (A8002)
            else if (type === "A8002") {
            let weekdayStr = "";
        
            if (obj.weekday_list) {
                if (obj.weekday_list.split(",").length === 7) {
                weekdayStr = "전체 요일마다";
                } else {
                weekdayStr = obj.weekday_list
                    .replaceAll(",", "/")
                    .replace("0", "월")
                    .replace("1", "화")
                    .replace("2", "수")
                    .replace("3", "목")
                    .replace("4", "금")
                    .replace("5", "토")
                    .replace("6", "일") + "마다";
                }
            }
        
            const time = obj.event_time ? `${obj.event_time}시에` : "";
            return [weekdayStr, time].filter(Boolean).join(" ");
            }
        
            // 실시간 (A8003)
            else if (type === "A8003") {
            let weekdayStr = "";
            if (obj.weekday_list) {
                if (obj.weekday_list.split(",").length === 7) {
                weekdayStr = "전체 요일";
                } else {
                weekdayStr = obj.weekday_list
                    .replaceAll(",", "/")
                    .replace("0", "월")
                    .replace("1", "화")
                    .replace("2", "수")
                    .replace("3", "목")
                    .replace("4", "금")
                    .replace("5", "토")
                    .replace("6", "일");
                }
            }
        
            let cycle = "";
            if (obj.real_time_cycle) {
                const val = Number(obj.real_time_cycle);
                if (val < 60) {
                cycle = `${val}분마다`;
                } else {
                const hours = Math.floor(val / 60);
                const minutes = val % 60;
                cycle = minutes === 0 ? `${hours}시간마다` : `${hours}시간 ${minutes}분마다`;
                }
            }
        
            const range =
                obj.real_time_start_hour && obj.real_time_end_hour
                ? `${obj.real_time_start_hour}시~${obj.real_time_end_hour}시까지`
                : "";
        
            return [weekdayStr, range, cycle].filter(Boolean).join(" ");
            }
        } else if (obj.reservation_use_yn == "Y") {
            return `예약일 ${obj.reservation_date} ${obj.reservation_hour.toString().padStart(2, '0')}:00에`
        }
      
        return "";
    }

    /** 카페24 자동진열 목록 */
    async loadCategoryAutoLayoutList(category_no, main_display_group){
        await APIs.rp.getCategoryAutoLayoutList()
            .then((res) => {
                const categoryAutoLayoutList = res.data.autodisplay;
                
                let isCategoryAutoLayoutUseYn = [false, false, false];
                let isMainAutoLayoutUseYn = false;
            
                categoryAutoLayoutList.forEach(({ category_no: autoCategoryNo, use_main: autoUseMain, display_group: autoDisplayGroup }) => {
                    if (category_no == autoCategoryNo && autoUseMain == "F" && this.state.clone_iframe_page_id == "robomd_cafe24_category_page") {
                        if (autoDisplayGroup == "1") {
                            isCategoryAutoLayoutUseYn[0] = true;
                        }
                        if (autoDisplayGroup == "2") {
                            isCategoryAutoLayoutUseYn[1] = true;
                        }
                        if (autoDisplayGroup == "3") {
                            isCategoryAutoLayoutUseYn[2] = true;
                        }
                    }
                    if (main_display_group == autoDisplayGroup && autoUseMain == "T" && this.state.clone_iframe_page_id == "robomd_cafe24_main_page") {
                        isMainAutoLayoutUseYn = true;
                    }
                });
            
                this.setState({
                    is_main_auto_display_use: isMainAutoLayoutUseYn,
                    is_category_auto_display_use: isCategoryAutoLayoutUseYn.some(useYn => useYn)
                }, () => {
                    console.log("category_no", category_no)
                    console.log("is_category_auto_display_use", this.state.is_category_auto_display_use)
                });
            })
            .catch((error) => {
                alert("카페24 자동진열 목록 조회에 실패하였습니다.");
            });
    }

    cloneRpEventSetting() {
        this.setState({
            show_save_loading_dialog: true,
        })

        const config = {
            headers: {
                'content-type': 'application/json;'
            },
        }

        const clone_cafe24_category_no_list = this.state.clone_cafe24_category_no_list;
        const cafe24_category_no_list_str = clone_cafe24_category_no_list.filter(v => v !== "").join(",");

        const body = {
            template_id: this.state.org_event_setting_obj.template_id,

            clone_iframe_page_id: this.state.clone_iframe_page_id,
            clone_cafe24_main_display_group: this.state.clone_cafe24_main_display_group,
            clone_cafe24_category_no: this.state.clone_cafe24_category_no,
            clone_cafe24_category_display_group: this.state.clone_cafe24_category_display_group,
            clone_cafe24_product_cnt: this.state.clone_cafe24_product_cnt,

            clone_cafe24_category_display_type: this.state.clone_cafe24_category_display_type,
            clone_cafe24_category_no_list: cafe24_category_no_list_str,

            category_no_1: this.state.category_no_1,
            category_no_2: this.state.category_no_2,
            category_no_3: this.state.category_no_3,
            category_no_4: this.state.category_no_4,

            excludeCategoryList: this.state.excludeCategoryList,

            excludedKeywords: this.state.excludedKeywords,
            includedKeywords: this.state.includedKeywords,

            totalItemCount: this.state.totalItemCount,

            clone_cafe24_main_display_group_name: this.state.clone_selected_display_name_group,
            clone_cafe24_category_name: this.state.clone_selected_last_category_name,

            is_break: this.state.is_break,

            is_check_not_modify_1: this.state.is_check_not_modify_1,
            is_check_not_modify_2: this.state.is_check_not_modify_2,
            is_check_not_modify_3: this.state.is_check_not_modify_3,
            is_check_not_modify_4: this.state.is_check_not_modify_4,
            is_check_not_modify_5: this.state.is_check_not_modify_5,
            is_check_not_modify_6: this.state.is_check_not_modify_6,

            price_cd: this.state.selected_price_cd
        }

        http.post("/rest/shop/rp/cafe24ProductProductSetting/clone", body, config)
        .then((res) => {
            if (res.data.code == "200") {
                // alert("저장하였습니다.");
                this.createRpCafe24ProductPreview(res.data.iframe_page_id, res.data.iframe_html_id);
            } else {
                console.log("저장에 실패하였습니다. 1");
                this.setState({
                    show_save_loading_dialog: false,
                })
            }
        })
        .catch((error) => {
            console.log("저장에 실패하였습니다. 2", error);
            this.setState({
                show_save_loading_dialog: false,
            })
        });
    }

    createRpCafe24ProductPreview (iframe_page_id, iframe_html_id) {
        const config = {
            headers: {
                'content-type': 'application/json;'
            },
        }

        const body = {
            iframe_page_id,
            iframe_html_id
        }

        http.post("/rest/shop/rp/cafe24/productPreview", body, config)
        .then((res) => {
            if (res.data.code == "200") {
                // alert("저장하였습니다.");
                this.setState({
                    show_save_loading_dialog: false,
                    show_save_dialog: true,
                    rp_event_setting_link: ("/shop/rp/event/product/cafe24List"
                                                +"?page_id="+iframe_page_id
                                                +"&html_id="+iframe_html_id)
                })
                // window.location.href = ""
            } else {
                console.log("미리보기 생성에 실패하였습니다.");
                this.setState({
                    show_save_loading_dialog: false,
                })
            }
        })
        .catch((error) => {
            console.log("미리보기 생성에 실패하였습니다.", error);
            this.setState({
                show_save_loading_dialog: false,
            })
        });
    }

    onCheckNonModify() {
        this.setState({
            ["is_check_not_modify_"+this.state.current_clone_Step] : !this.state["is_check_not_modify_"+this.state.current_clone_Step]
        })
    }

    /** 카테고리 설정 조회 (카페24) */
    async checkCafe24CategorySettingByOrgCategoryNo () {
        await APIs.rp.getCheckingCafe24CategorySettingSingle(this.state.org_event_setting_obj["cafe24_category_no_list"])
            .then((res) => {
                if(res.data.code == "200"){
                    if (res.data.product_category) {
                        this.setState({
                            org_sub_category_product_display : res.data.product_category.sub_category_product_display
                        })
                    }
                } 
            })
            .catch((error) => {
                this.setState({
                    clone_sub_category_product_display : "F"
                })
                // alert("카테고리 분류 조회에 실패하였습니다.");
            });
    }

    render() {
        return (
            <div>
                <div className="rpClonePopup" style={{position:"fixed", zIndex: 99999}}>
                    {this.state.show_clone_popup_frame &&
                        <PopupFrameV2
                            className={"rpClonePopupFrame"}
                            width={"90vw"}
                            maxWidth={"90vw"}
                            height={"90vh"}
                            maxHeight={"90vh"}
                            padding={"40px"}
                            onClose={() => {
                                this.props.onClose(); // 상위에서 showClonePopup=false 처리
                            }}
                        >
                            <div style={{display:"flex", flexDirection:"column", height: "100%"}}>
                                <div style={{display:"flex", flexDirection:"column", marginBottom: "20px"}}>
                                    <h3 style={{color:"#00ACB2"}}>AI 자동설정 복제</h3>
                                    {
                                            this.state.current_clone_Step == "1"
                                            ?   ""
                                            :   this.state.current_clone_Step == "3"
                                                ?   ""
                                                :   this.state.current_clone_Step == "4"
                                                    ?   ""
                                                    :   this.state.current_clone_Step == "5"
                                                        ?   ""
                                                        :   this.state.current_clone_Step == "6"
                                                            ?   ""
                                                            :   ""
                                    }
                                </div>
                                {
                                    this.state.current_clone_Step == "1"
                                    ?   <div style={{display: "block", position:"relative", flex:"1", overflow: "auto", borderRadius:"10px",
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center'
                                        }}>
                                            {
                                                this.state["is_check_not_modify_"+this.state.current_clone_Step] &&
                                                <h4 className="not_modify">
                                                변경 안 함<br/>
                                                기존 설정을 그대로 사용합니다.
                                                </h4>
                                            }
                                            <div className='subTitle' style={{marginTop: "10px"}}>원본 자동 진열을 등록해서, 다른 진열 위치에 동일하게 적용할 수 있어요.<br/>아래에서 적용할 진열 위치를 선택해주세요.</div>
                                            <RpProductListStatisticsForPopup
                                                onChangeMainGroupOrCategory={this.onChangeMainGroupOrCategory}
                                                iframePageId={this.state.clone_iframe_page_id}
                                                cafe24MainDisplayGroup={this.state.clone_cafe24_main_display_group}
                                                cafe24CategoryNo={this.state.clone_cafe24_category_no}
                                                cafe24CategoryDisplayGroup={this.state.clone_cafe24_category_display_group}
                                                cafe24CategoryDisplayType={this.state.clone_cafe24_category_display_type}
                                                subCategoryProductDisplay={this.state.clone_sub_category_product_display}
                                                categoryDepth={this.state.clone_category_depth}
                                                cafe24CategoryNoList={this.state.clone_cafe24_category_no_list}
                                                cafe24CategoryList={this.state.clone_cafe24_category_list}
                                            />
                                        </div>
                                    :   this.state.current_clone_Step == "2"
                                        ?   <h4 style={{display:"flex", width:"100%", height: "100%", justifyContent: "center", alignItems: "center"}}>
                                            현재 설정 그대로 등록하시겠습니까, 아니면 일부 설정을 변경하시겠습니까?
                                            </h4>
                                        :   this.state.current_clone_Step == "3"
                                            ?   
                                                <div style={{
                                                    position:"relative", 
                                                    padding: '10px 0',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    justifyContent: 'center'
                                                }}>
                                                    {
                                                        this.state["is_check_not_modify_"+this.state.current_clone_Step] &&
                                                        <h4 className="not_modify">
                                                        변경 안 함<br/>
                                                        기존 설정을 그대로 사용합니다
                                                        </h4>
                                                    }
                                                    <div className='subTitle'>
                                                        <div>이전 단계에서 선택한 진열 위치에 <b>노출할 상품의 카테고리</b>를 선택해주세요</div>
                                                        <div className="flexBox" style={{
                                                        color: "gray",
                                                        fontSize: "14px",
                                                        alignItems: "center",
                                                        gap: "4px"
                                                        }}>
                                                        <span
                                                        style = {{
                                                            display: "flex",
                                                            alignItems: "center",
                                                        }}
                                                        ><svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="gray" class="bi bi-info-circle-fill" viewBox="0 0 16 16"><path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"></path></svg></span> 
                                                        <span>등록 시 선택한 상품 카테고리는 전체 알고리즘 순서에 일괄 적용됩니다.</span>
                                                        </div>
                                                        <div className="flexBox" style={{
                                                        color: "gray",
                                                        fontSize: "14px",
                                                        alignItems: "center",
                                                        gap: "4px"
                                                        }}>
                                                        <span
                                                        style = {{
                                                            display: "flex",
                                                            alignItems: "center",
                                                        }}
                                                        ><svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="gray" class="bi bi-info-circle-fill" viewBox="0 0 16 16"><path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"></path></svg></span> 
                                                        <span>예: “여성 {">"} 아우터”를 선택하면, 이 카테고리의 상품으로 자동진열이 구성됩니다.</span>
                                                        </div>
                                                    </div>
                                                    <RpSelectCategory 
                                                        id = "RpSelectCategory"
                                                        onCategoryChange={this.onCategoryChange.bind(this)}
                                                        category_no_1 = {this.state.category_no_1}
                                                        category_no_2 = {this.state.category_no_2}
                                                        category_no_3 = {this.state.category_no_3}
                                                        category_no_4 = {this.state.category_no_4}
                                                        category_list_1 = {this.state.category_list_1}
                                                        category_list_2 = {this.state.category_list_2}
                                                        category_list_3 = {this.state.category_list_3}
                                                        category_list_4 = {this.state.category_list_4}
                                                        boundingSelector = ".rpClonePopupFrame .common_popup_frame_v2_content"
                                                    />
                                                </div>
                                            :   this.state.current_clone_Step == "4"   
                                                ?   <div style={{
                                                        position:"relative", 
                                                        padding: '10px 0',
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        justifyContent: 'center'
                                                    }}>
                                                    {
                                                        this.state["is_check_not_modify_"+this.state.current_clone_Step] &&
                                                        <h4 className="not_modify">
                                                        변경 안 함<br/>
                                                        기존 설정을 그대로 사용합니다
                                                        </h4>
                                                    }
                                                    {/* <div className='subTitle'>선택한 자동진열위치에 <b>제외</b>하고 싶은 상품의 <b>카테고리</b>를 모두 선택해주세요</div> */}
                                                    <div className='subTitle'>
                                                        <div>이전 단계에서 선택한 진열 위치에 <b>제외할 상품의 카테고리</b>를 선택해주세요</div>
                                                        <div className="flexBox" style={{
                                                        color: "gray",
                                                        fontSize: "14px",
                                                        alignItems: "center",
                                                        gap: "4px"
                                                        }}>
                                                        <span
                                                        style = {{
                                                            display: "flex",
                                                            alignItems: "center",
                                                        }}
                                                        ><svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="gray" class="bi bi-info-circle-fill" viewBox="0 0 16 16"><path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"></path></svg></span> 
                                                        <span>등록 시 제외한 상품 카테고리는 전체 알고리즘 순서에 일괄 적용됩니다.</span>
                                                        </div>
                                                        <div className="flexBox" style={{
                                                        color: "gray",
                                                        fontSize: "14px",
                                                        alignItems: "center",
                                                        gap: "4px"
                                                        }}>
                                                        <span
                                                        style = {{
                                                            display: "flex",
                                                            alignItems: "center",
                                                        }}
                                                        ><svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="gray" class="bi bi-info-circle-fill" viewBox="0 0 16 16"><path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"></path></svg></span> 
                                                        <span>예: 악세사리 카테고리, 이벤트 상품, 특정 브랜드, 소형 카테고리 등을 제외할 수 있어요.</span>
                                                        </div>  
                                                    </div>
                                                    {this.state.excludeCategoryList.map((item, idx) => (
                                                        <>
                                                        {
                                                            idx >= 1
                                                            && <div style={{width: "350px", height:"1px", borderTop:"solid 1px #e9e9e9", marginBottom: "8px"}}></div>
                                                        }
                                                        <div className="flexBox excludeCategory" key={item.id} style={{ marginBottom: '8px', alignItems: "flex-start"}}>
                                                            <RpSelectCategory
                                                            id = {"RpSelectCategory_"+idx}
                                                            is_exclude={true}
                                                            category_no_1={item.category_no_1}
                                                            category_no_2={item.category_no_2}
                                                            category_no_3={item.category_no_3}
                                                            category_no_4={item.category_no_4}
                                                            category_list_1={item.category_list_1}
                                                            category_list_2={item.category_list_2}
                                                            category_list_3={item.category_list_3}
                                                            category_list_4={item.category_list_4}
                                                            onCategoryChange={(cat1, cat2, cat3, cat4, list1, list2, list3, list4) =>
                                                                this.handleCategoryChange(item.id, cat1, cat2, cat3, cat4, list1, list2, list3, list4)
                                                            }
                                                            boundingSelector = ".rpClonePopupFrame .common_popup_frame_v2_content"
                                                            />
                                                            <button style={{paddingTop:"6px", marginLeft:"8px"}} onClick={() => this.handleAddExcludeCategory(item.id)}> 
                                                                <img src={default_plus_img}/>
                                                            </button>
                                                            {
                                                                idx >= 1 &&
                                                                <button style={{paddingTop:"6px", marginLeft:"8px"}} onClick={() => this.handleRemoveExcludeCategory(item.id)}>
                                                                    <img src={default_minus_img}/>
                                                                </button>
                                                            }
                                                        </div>
                                                        </>
                                                    ))}
                                                    </div>
                                                :   this.state.current_clone_Step == "5"
                                                    ?   
                                                    <div style={{
                                                        position:"relative", 
                                                        padding: '10px 0px 0px 0px',
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        justifyContent: 'center'
                                                    }}>
                                                    {
                                                        this.state["is_check_not_modify_"+this.state.current_clone_Step] &&
                                                        <h4 className="not_modify">
                                                        변경 안 함<br/>
                                                        기존 설정을 그대로 사용합니다
                                                        </h4>
                                                    }
                                                            <div className='subTitle'>
                                                                <b>[제외할 키워드 입력]</b>
                                                                <br/>예: “샘플”, “이벤트”
                                                            </div>
                                                            <RpProductKeywordInputList 
                                                            initialKeywordList={this.state.excludedKeywords}
                                                            palceholder={"제외할 상품명의 단어를 입력해 주세요."}
                                                            org_keyword_list={this.state.org_unique_product_except_keyword_list}
                                                            onChange={this.handleExcludeKeywordChange} />
                                                            <div className='subTitle'>
                                                                <b>[포함할 키워드 입력]</b>
                                                                <br/>예: “주문폭주”, “제작”, “반팔”
                                                            </div>
                                                            <RpProductKeywordInputList 
                                                            initialKeywordList={this.state.includedKeywords}
                                                            palceholder={"추가할 상품명의 단어를 입력해 주세요."}
                                                            org_keyword_list={this.state.org_unique_product_keyword_list}
                                                            onChange={this.handleIncludeKeywordChange} />

                                                            <div div className='subTitle flexBox' style={{
                                                                marginTop:"8px",
                                                                alignItems: "center",
                                                                fontSize: "14px",
                                                                gap: "0px",
                                                                flexWrap: "wrap"
                                                            }}>
                                                            <span class="i_notice">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle-fill" viewBox="0 0 16 16">
                                                                    <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
                                                                </svg>
                                                            </span>
                                                            {/* <div>원본 진열 설정에서 <b>키워드가 등록되어 있던 알고리즘에만</b> 변경 내용이 반영됩니다.</div> */}
                                                            <div>입력한 키워드는 <b>키워드 기능이 켜진 알고리즘에만</b> 적용됩니다.</div>
                                                            </div>
                                                        </div>
                                                    :   this.state.current_clone_Step == "6"
                                                        ?   
                                                            <div style={{
                                                                position:"relative", 
                                                                padding: '10px 0',
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                justifyContent: 'center'
                                                            }}>
                                                                {
                                                                    this.state["is_check_not_modify_"+this.state.current_clone_Step] &&
                                                                    <h4 className="not_modify">
                                                                    변경 안 함<br/>
                                                                    기존 설정을 그대로 사용합니다
                                                                    </h4>
                                                                }
                                                                <div className='subTitle'>총 변경될 상품진열 <b>개수</b>를 체크해주세요</div>
                                                                <RpTotalItemCountInput
                                                                    initialCount={this.state.totalItemCount}
                                                                    max_item_analysis={this.state.max_item_analysis}
                                                                    onChange={this.handleTotalItemCountChange}
                                                                />
                                                            </div>
                                                        :   this.state.current_clone_Step == "7"
                                                            ?   <>
                                                                    <div class="auto-setup-complete-wrap">
                                                                        <p class="setup-complete-title">자동 설정 등록이 완료되었습니다!
                                                                        <br/>선택하신 진열 위치에 설정된 조건과 상품 구성이 모두 등록되었습니다.</p>

                                                                        {
                                                                            this.state.clone_iframe_page_id == "robomd_cafe24_category_page" 
                                                                            && ((this.state.is_check_not_modify_1 == false && this.state.clone_sub_category_product_display == "T")
                                                                            || (this.state.is_check_not_modify_1 == true && this.state.org_sub_category_product_display == "T"))
                                                                            &&
                                                                            <p class="setup-warning">
                                                                                ❗ 카테고리 하위분류설정을 <span class="text-bold">사용안함</span> 상태로 변경해주셔야<br/>
                                                                                자동진열이 정상동작합니다.
                                                                            </p>
                                                                        }
                                                                        {
                                                                            ((this.state.clone_iframe_page_id == "robomd_cafe24_main_page" && this.state.is_main_auto_display_use) 
                                                                            || (this.state.clone_iframe_page_id == "robomd_cafe24_category_page" && this.state.is_category_auto_display_use)) &&
                                                                            <p class="setup-warning">
                                                                                ❗ 카페24 자동진열이 ON상태로 <span class="text-bold">OFF</span>상태로 변경해주셔야<br/>
                                                                                자동진열이 정상동작합니다.
                                                                            </p>
                                                                        }
                                                                        {
                                                                            !(this.state.clone_iframe_page_id == "robomd_cafe24_category_page" 
                                                                                && ((this.state.is_check_not_modify_1 == false && this.state.clone_sub_category_product_display == "T")
                                                                                || (this.state.is_check_not_modify_1 == true && this.state.org_sub_category_product_display == "T"))) 
                                                                            && !((this.state.clone_iframe_page_id == "robomd_cafe24_main_page" && this.state.is_main_auto_display_use) 
                                                                            || (this.state.clone_iframe_page_id == "robomd_cafe24_category_page" && this.state.is_category_auto_display_use)) 
                                                                            ? <>
                                                                            <p class="setup-subtext">앞으로 {
                                                                                this.state.is_check_not_modify_1
                                                                                ?   this.state.org_event_setting_obj.iframe_page_id == "robomd_cafe24_main_page"
                                                                                    ? "메인"
                                                                                    : "카테고리"
                                                                                :   this.state.clone_iframe_page_id == "robomd_cafe24_main_page"
                                                                                    ? "메인"
                                                                                    : "카테고리"
                                                                                } 페이지의 {
                                                                                    this.state.is_check_not_modify_1
                                                                                    ?   this.state.org_event_setting_obj.cafe24_display_name
                                                                                    :   this.state.clone_iframe_page_id == "robomd_cafe24_main_page"
                                                                                        ? this.state.clone_selected_display_name_group
                                                                                        : this.state.clone_selected_last_category_name
                                                                                } 위치에 총 {
                                                                                    this.state.is_check_not_modify_6
                                                                                    ? this.state.org_event_setting_obj.product_cnt
                                                                                    : this.state.totalItemCount
                                                                                }개의 상품이 
                                                                                {
                                                                                  this.state.org_event_setting_obj 
                                                                                  && this.state.org_event_setting_obj["auto_create_yn"] == "Y"
                                                                                  ? (" " + this.getScheduleText(this.state.org_event_setting_obj))
                                                                                  : this.state.org_event_setting_obj.reservation_use_yn == "Y"
                                                                                    ? (" " + this.getScheduleText(this.state.org_event_setting_obj))
                                                                                    : ""
                                                                                }
                                                                                {" 자동진열 됩니다."}</p>

                                                                                <p class="setup-subtext">
                                                                                    자동진열 목록에 가면 언제든지 조건을 변경하실 수 있습니다
                                                                                </p>
                                                                                <p class="setup-subtext">
                                                                                    <b>지금 등록된 설정을 저장하고, 상품을 미리 확인해보시겠어요?</b>
                                                                                </p>
                                                                            </>
                                                                            : 
                                                                            <>
                                                                                <p class="setup-subtext">설정을 저장하시고 카페24관리자에서 변경을 진행해 주십시요</p>
                                                                                <p class="setup-link">
                                                                                    🎯 <a href="https://iclave.notion.site/24-1d863ab4c3ce80fd9882c61eb776a602?pvs=4" target="_blank" class="link-style">카페24 설정 변경 방법 안내</a>
                                                                                </p>
                                                                            </>
                                                                        }
                                                                    </div>
                                                                </>
                                                            :   ""
                                }
                                <div style={{marginTop: "30px"}}>{/* 여백 */}</div>
                                {/* <div style={{marginBottom: "15px"}}>
                                {
                                    this.state.current_clone_Step == "2" || this.state.current_clone_Step == "7"
                                    ?   ""    
                                    :
                                        <CheckBox
                                            checked={this.state["is_check_not_modify_"+this.state.current_clone_Step]}
                                            onChangeCheck={e => this.onCheckNonModify(e)}
                                        >
                                            <div style={{marginLeft:"5px", userSelect: 'none'}}>
                                            {
                                                (
                                                    this.state.current_clone_Step == "1"
                                                    ?   "진열 위치를 원본과 동일하게 등록하기"
                                                    :   this.state.current_clone_Step == "3"
                                                        ?   "등록할 상품 카테고리를 원본과 동일하게 등록하기"
                                                        :   this.state.current_clone_Step == "4"
                                                            ?   "제외 상품 카테고리를 원본과 동일하게 등록하기"
                                                            :   this.state.current_clone_Step == "5"
                                                                ?   "키워드를 원본과 동일하게 등록하기"
                                                                :   this.state.current_clone_Step == "6"
                                                                    ?   "상품 개수를 원본과 동일하게 등록하기"
                                                                    :   ""
                                                )
                                                +" 동일하게 복제"
                                            }
                                            </div>
                                        </CheckBox>
                                }
                                </div> */}
                                <div className='flexBox' style={{justifyContent: "center"}}>
                                    {
                                        this.state.current_clone_Step == "2"
                                        ?    
                                        <>
                                            <div className="prevButton" style={{marginRight:"10px"}}>
                                                <Button onClick={() => this.prevCloneStep(this.state.current_clone_Step)}>이전</Button>
                                            </div>
                                            <div className="breakButton" style={{marginRight:"10px"}}>
                                                <Button onClick={() => this.nextCloneStep(this.state.current_clone_Step, true)}>현재 설정 그대로</Button>
                                            </div>
                                        </>
                                        :    this.state.current_clone_Step > 1
                                            ?   <div className="prevButton" style={{marginRight:"10px"}}>
                                                    <Button onClick={() => this.prevCloneStep(this.state.current_clone_Step)}>이전</Button>
                                                </div>
                                            :   null
                                    }
                                    <div className="continueButton">
                                        <Button onClick={() => {
                                            if (this.state.current_clone_Step == "7") {
                                                // 저장 및 미리보기 실행
                                                this.cloneRpEventSetting();
                                            } else {
                                                // 다음
                                                this.nextCloneStep(this.state.current_clone_Step)
                                            }
                                        }}>{
                                            this.state.current_clone_Step == "2"
                                            ? "일부 설정 변경"
                                            : this.state.current_clone_Step != "7" ? "다음" : "저장 및 확인"
                                         }</Button>
                                    </div>
                                </div>
                            </div>
                        </PopupFrameV2>
                    }
                    {this.state.show_save_loading_dialog &&
                        <SaveDialogV2
                            content={"저장 중 입니다."}
                            button_list={[{
                                title : "확인",
                                display_yn : "N",
                                event_method : () => { this.handleToggle("show_save_loading_dialog") }
                            }]}
                        />
                    }
                    {this.state.show_save_dialog &&
                        <SaveDialogV2
                            content={"저장하였습니다."}
                            button_list={[{
                                title : "확인",
                                event_method : () => { 
                                    // this.handleToggle("show_save_dialog");
                                    window.location.href=this.state.rp_event_setting_link;
                                    this.props.onClose(); // 상위에서 showClonePopup=false 처리
                                    if (typeof this.props.loadRpEventEventSetting == 'function') {
                                        this.props.loadRpEventEventSetting();
                                    }
                                 }
                            }]}
                        />
                    }
                    {this.state.show_over_total_cnt &&
                        <BasicDialogV2
                            content={`<h3>⚠️</h3><p>cafe24 메인 진열에 저장할 수 있는<br/>상품 수는 최대 200개입니다.</p>`}
                            button_list={[{
                                title : "확인",
                                event_method : () => { this.setState({show_over_total_cnt: false}) }
                            }]}
                        />
                    }
                    {this.state.show_non_total_cnt &&
                        <BasicDialogV2
                            content={`<h3>⚠️</h3><p>상품진열 개수를 입력해 주세요.</p>`}
                            button_list={[{
                                title : "확인",
                                event_method : () => { this.setState({show_non_total_cnt: false}) }
                            }]}
                        />
                    }
                    {this.state.show_non_select_page &&
                        <BasicDialogV2
                            content={`<h3>⚠️</h3><p>진열 위치를 선택해 주세요.</p>`}
                            button_list={[{
                                title : "확인",
                                event_method : () => { this.setState({show_non_select_page: false}) }
                            }]}
                        />
                    }
                </div>
            </div>
        )
    };
}